import { Options as PlyrOptions } from 'plyr';
import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from 'vue';

import type { VideoTrackingOptions } from './video-player';

export interface VideoOptionsInput {
  tapToToggle?: boolean;
  plyr?: boolean;
  plyrOptions?: PlyrOptions;
  prefetch?: boolean;
  hasPlaylistCapabilities?: boolean;
  videoTracking?: VideoTrackingOptions;
  controlsHtml?: string | null;
}

export function useVideoOptions(options: MaybeRefOrGetter<VideoOptionsInput>): ComputedRef<Record<string, unknown>> {
  return computed(() => {
    const opts = toValue(options);

    const result: Record<string, unknown> = {
      tapToToggle: opts.tapToToggle ?? false,
      plyr: opts.plyr ?? false,
      prefetch: opts.prefetch ?? false,
      hasPlaylistCapabilities: opts.hasPlaylistCapabilities ?? false,
    };

    const plyrOptions: Plyr.Options = { ...opts.plyrOptions };

    if (opts.controlsHtml != null) {
      plyrOptions.controls = opts.controlsHtml;
    }

    if (opts.plyr && Object.keys(plyrOptions).length > 0) {
      result.plyrOptions = plyrOptions;
    }

    if (opts.videoTracking && Object.keys(opts.videoTracking).length > 0) {
      result.videoTracking = opts.videoTracking;
    }

    return result;
  });
}
